import firebase from 'firebase'
import 'firebase/firestore'

// firebase init goes here
const config = {
	apiKey: "AIzaSyBopaLxV1ggG0cc6EjlgI_utj2G8PDrzTQ",
	//authDomain: "flli-catalog-ccc72.firebaseio.com",
	databaseURL: "https://flli-catalog-ccc72.firebaseio.com",
	projectId: "flli-catalog-ccc72",
	storageBucket: "",
	messagingSenderId: ""
}
firebase.initializeApp(config)

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser

// firebase collections
const usersCollection = db.collection('users')
const feedbackCollection = db.collection('feedback')
const myCoursesCollection = db.collection('mycourses')

export {
    db,
    auth,
    currentUser,
	usersCollection,
	feedbackCollection,
    myCoursesCollection
}